import { convertGemacXML, convertHolterECG } from '../controllers/study-controller';
import { logger } from 'packages/logger';

export const getCsvFromXML = async (xmlString: File, waveformId: string) => {
  try {
    return await convertGemacXML(xmlString, waveformId);
  } catch (error) {
    logger.error('error converting XML in getCsvFromXML ', error);
    throw error;
  }
};

export const getCsvFromECG = async (ECGFile: File, waveformId: string, holterOffset: number) => {
  try {
    return await convertHolterECG(ECGFile, waveformId, holterOffset);
  } catch (error) {
    logger.error('error converting XML in getCsvFromECG ', error);
    throw error;
  }
};
